import {
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILED,
    ACCEPT_TASK,
    CANCEL_TASK,
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { language } from '../../config';
import { updateProfile } from "./authactions";

export const fetchTasks = () => (dispatch) => (firebase) => {

    const {
        auth,
        tasksRef,
        bookingRequestRef
    } = firebase;

    let uid = auth.currentUser.uid;
    dispatch({
        type: FETCH_TASKS,
        payload: null,
    });
    tasksRef().on("value", (snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const arr = Object.keys(data)
                .filter(i => data[i].requestedDrivers && data[i].requestedDrivers[uid])
                .map(i => {
                    data[i].id = i;
                    return data[i];
                });

            dispatch({
                type: FETCH_TASKS_SUCCESS,
                payload: arr,
            });
            // var taskArray = [];
            // bookingRequestRef(Object.keys(data)[0]).on("value", (snapshot1) => {
            //     let data1 = snapshot1.val()
            //     const requestedDriverArray = Object.values(data1)
            //         .filter(item => item.driverId === uid && item.notificationStatus === 1);
            //     if (requestedDriverArray.length > 0) {
            //         taskArray = Object.values(data)
            //             .map(i => {
            //                 data[i].id = i;
            //             });
            //     }
            //     dispatch({
            //         type: FETCH_TASKS_SUCCESS,
            //         payload: taskArray,
            //     });
            // })
        } else {
            dispatch({
                type: FETCH_TASKS_FAILED,
                payload: language.no_tasks,
            });
        }
        //end
    });
};


export const acceptTask = (userAuthData, task) => (dispatch) => (firebase) => {

    const {
        trackingRef,
        singleUserRef,
        singleBookingRef,
        requestedDriversRef,
        bookingRequestRef,
        singleBookingRequestRef
    } = firebase;

    let uid = userAuthData.uid;

    singleUserRef(uid).once('value', snapshot => {
        let profile = snapshot.val();

        task.driver = uid;
        task.driver_image = profile.profileImage ? profile.profileImage : "";
        task.driver_name = profile.firstName + ' ' + profile.lastName;
        task.driver_contact = profile.mobile ? profile.mobile : '';
        task.driver_token = profile.pushToken ? profile.pushToken : '';
        task.vehicle_number = profile.vehicleNumber ? profile.vehicleNumber : '';
        task.driverRating = profile.ratings ? profile.ratings.userrating : "0";
        task.fleetadmin = profile.fleetadmin ? profile.fleetadmin : '';
        task.status = "ACCEPTED";
        task.carType = profile.carType ? profile.carType : '';

        userAuthData.profile = profile;

        singleBookingRef(task.id).update(task).then(() => {

            bookingRequestRef(task.id).on("value", (snapshot1) => {
                if (snapshot1.val()) {
                    let data = snapshot1.val()
                    Object.values(data).map((item, i) => {
                        if (item.driverId === uid) {
                            item.bookingStatus = 1
                            singleBookingRequestRef(Object.keys(data)[i]).update(item)
                        }
                    })
                }
            })


            requestedDriversRef(task.id).remove();
            updateProfile(userAuthData, { queue: true })(dispatch)(firebase);
            RequestPushMsg(task.customer_token, language.notification_title, task.driver_name + language.accept_booking_request);
        });

        trackingRef(task.id).push({
            at: new Date().getTime(),
            status: 'ACCEPTED',
            lat: profile.location.lat,
            lng: profile.location.lng
        });

    })

    dispatch({
        type: ACCEPT_TASK,
        payload: { task: task },
    });
};

export const bookingReq = (id) => (dispatch) => (firebase) => {

    const {
        auth,
        singleBookingRequestRef,
        bookingRequestRef,
        requestedDriversRef
    } = firebase;

    let uid = auth.currentUser.uid;
    bookingRequestRef(id).on("value", (snapshot1) => {
        if (snapshot1.val()) {
            let data = snapshot1.val()
            Object.values(data).map((item, i) => {
                if (item.driverId === uid && item.bookingStatus === '') {
                    item.bookingStatus = 2
                    singleBookingRequestRef(Object.keys(data)[i]).update(item)
                }
            })
        }
    })

    dispatch({
        type: ACCEPT_TASK,
        payload: { task: null },
    });
};

export const cancelTask = (bookingId) => (dispatch) => (firebase) => {

    const {
        auth,
        singleTaskRef,
        bookingRequestRef,
        singleBookingRequestRef
    } = firebase;

    let uid = auth.currentUser.uid;
    dispatch({
        type: CANCEL_TASK,
        payload: { uid: uid, bookingId: bookingId },
    });
    singleTaskRef(uid, bookingId).remove();
    bookingRequestRef(bookingId).on("value", (snapshot1) => {
        if (snapshot1.val()) {
            let data = snapshot1.val()
            Object.values(data).map((item, i) => {
                if (item.driverId === uid) {
                    item.bookingStatus = 0
                    singleBookingRequestRef(Object.keys(data)[i]).update(item)
                }
            })
        }
    })
};